export interface QuickReply {
  id: string;
  title: string;
  category: string;
  message: string;
  changeStatusTo?: string;
}

export const QUICK_REPLIES: QuickReply[] = [
  {
    id: 'cancelamento-prazo',
    title: 'Cancelamento dentro do prazo',
    category: 'Cancelamento',
    message:
      'Olá, {nome}! O cancelamento do pedido deve ser solicitado diretamente pelo titular da compra no aplicativo da Banca do Ingresso.\n\n' +
      'O cancelamento é permitido em até 7 dias corridos após a compra, conforme o direito de arrependimento previsto no art. 49 do Código de Defesa do Consumidor, desde que o evento esteja a mais de 24 horas da data de realização.\n\n' +
      'Após a aprovação, o reembolso será realizado pela mesma forma de pagamento, e o prazo pode variar conforme a instituição financeira.\n\n' +
      'Como realizar o cancelamento:\n' +
      '• Acesse o aplicativo com seu CPF e senha\n' +
      '• Vá em Ingressos\n' +
      '• Selecione Ver detalhes\n' +
      '• Clique em Cancelar pedido',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'cancelamento-fora-prazo',
    title: 'Cancelamento fora do prazo',
    category: 'Cancelamento',
    message:
      'Olá, {nome}! Verificamos sua solicitação.\n\n' +
      'Conforme a legislação vigente, o cancelamento por arrependimento para compras online deve ser solicitado em até 7 dias corridos após a compra.\n\n' +
      'Como sua solicitação foi feita após esse prazo, infelizmente não é possível seguir com o cancelamento pela plataforma.',
    changeStatusTo: 'Resolvido',
  },

  {
    id: 'cancelamento-evento-proximo',
    title: 'Cancelamento - evento próximo',
    category: 'Cancelamento',
    message:
      'Olá, {nome}! Quando o evento acontece em menos de 7 dias a partir da data da compra, o cancelamento pode ser solicitado com até 48 horas de antecedência da realização do evento.\n\n' +
      'Solicitações feitas fora desse prazo ou no dia do evento não podem ser aceitas.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'reembolso-cartao',
    title: 'Reembolso no cartão',
    category: 'Reembolso',
    message:
      'Olá, {nome}! Para pagamentos realizados no cartão de crédito, o reembolso é processado entre 30 e 40 dias após a confirmação do cancelamento.\n\n' +
      'O valor poderá constar na fatura atual ou na próxima, de acordo com a data de fechamento definida pelo banco emissor do cartão.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'reembolso-pix',
    title: 'Reembolso via PIX',
    category: 'Reembolso',
    message:
      'Olá, {nome}! Para pagamentos realizados via PIX, o reembolso é efetuado entre 20 e 30 dias após a confirmação do cancelamento.\n\n' +
      'O valor será devolvido na mesma conta bancária utilizada no pagamento.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'transferencia-regras',
    title: 'Transferência de ingresso',
    category: 'Transferência',
    message:
      'Olá, {nome}! A transferência do ingresso segue as seguintes regras:\n\n' +
      '• O favorecido deve possuir conta válida e já verificada na Banca do Ingresso\n' +
      '• A transferência pode ser feita em até 3 horas antes do início do evento\n' +
      '• Cada ingresso pode ser transferido apenas uma única vez\n' +
      '• Após a transferência, o ingresso ficará disponível somente na conta do favorecido\n\n' +
      'Passo a passo para transferir:\n' +
      '• Acesse o aplicativo com seu CPF e senha\n' +
      '• Vá em Ingressos\n' +
      '• Clique em Transferir ingresso\n' +
      '• Informe o CPF da pessoa favorecida\n' +
      '• No teclado, pressione “Done” para habilitar a confirmação\n' +
      '• Finalize a transferência',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'instabilidade-pagamento',
    title: 'Instabilidade no pagamento',
    category: 'Pagamento',
    message:
      'Olá, {nome}! Identificamos uma instabilidade momentânea no processamento de algumas compras.\n\n' +
      'Em alguns casos, o pagamento foi concluído, porém o ingresso pode ter permanecido temporariamente com status incorreto no sistema.\n\n' +
      'Nossa equipe já está atuando na regularização e, caso o pagamento tenha sido aprovado, a atualização será realizada em breve.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'evento-responsabilidade-produtor',
    title: 'Informações do evento',
    category: 'Evento',
    message:
      'Olá, {nome}! As orientações específicas do evento, incluindo regras de acesso, realização, cancelamento, adiamento e demais condições, são definidas exclusivamente pelo produtor do evento.\n\n' +
      'Recomendamos verificar as informações disponíveis na página do evento, na opção “Sobre”.\n\n' +
      'Caso a informação desejada não esteja disponível nessa área, orientamos entrar em contato diretamente com o Instagram oficial do evento.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'meia-entrada-validacao-previa',
    title: 'Validação de meia-entrada',
    category: 'Evento',
    message:
      'Olá, {nome}! A validação definitiva do documento de meia-entrada acontece somente no momento do acesso ao evento, mediante apresentação do comprovante exigido.\n\n' +
      'Por esse motivo, não conseguimos confirmar previamente a aprovação do benefício.\n\n' +
      'Em caso de dúvidas adicionais, orientamos verificar diretamente com o produtor do evento pelo Instagram oficial.',
    changeStatusTo: 'Resolvido',
  },

  {
    id: 'compra-ingresso',
    title: 'Compra de ingresso',
    category: 'Compra',
    message:
      'Olá, {nome}! A compra do ingresso pode ser realizada de forma rápida e segura pelo site oficial ou aplicativo da Banca do Ingresso.\n\n' +
      'Caso tenha dificuldade em localizar o evento ou concluir a compra pelo site, recomendamos tentar a compra diretamente pelo aplicativo, que pode apresentar melhor estabilidade em alguns dispositivos.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'validacao-facial',
    title: 'Validação facial',
    category: 'Cadastro',
    message:
      'Olá, {nome}! Para concluir a validação facial, orientamos que a foto seja feita com uma câmera de boa qualidade, em um ambiente bem iluminado e sem reflexos excessivos.\n\n' +
      'É importante estar sem boné, óculos, máscara ou qualquer acessório que cubra o rosto.\n\n' +
      'Mantenha o rosto centralizado na tela e evite luz forte atrás da cabeça.\n\n' +
      'Caso a validação não funcione corretamente pelo site, recomendamos tentar o processo diretamente pelo aplicativo da Banca do Ingresso.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'atendimento-encerrado',
    title: 'Encerrar atendimento',
    category: 'Encerramento',
    message:
      'Olá, {nome}! Seu atendimento foi finalizado.\n\n' +
      'Caso precise de novo suporte, estaremos à disposição pelos nossos canais oficiais.',
    changeStatusTo: 'Fechado',
  },
];
